/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M439 59v124.999l73 .001v212.209c0 31.811-25.788 57.6-57.6 57.6l-15.4-.001V454H57.6C25.788 454 0 428.212 0 396.4V59h439zm-46 46H46v275c0 15.464 12.536 28 28 28h319V105zm73 125h-27v175.915c14.912 0 27-12.088 27-27V230z" />
      <path d="M137 185h165c12.703 0 23 10.297 23 23s-10.297 23-23 23H137c-12.703 0-23-10.297-23-23s10.297-23 23-23zM137 282h165c12.703 0 23 10.297 23 23s-10.297 23-23 23H137c-12.703 0-23-10.297-23-23s10.297-23 23-23z" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconNews = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconNews.defaultProps = {
  theme,
};
IconNews.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconNews.displayName = 'IconNews';
export { IconNews };
